/**** Import de modules ****/
import React, { Component, useEffect, useState } from 'react'
import { Route, useLocation, Routes, Link, useHistory, Navigate, useNavigate, useParams } from 'react-router-dom'
import useScrollPosition from '@react-hook/window-scroll'
import PropTypes from 'prop-types'
import { ToastContainer, toast } from 'react-toastify';
import { Helmet } from "react-helmet";
import TagManager from 'react-gtm-module';

/**** Import des components ou containers ****/

import Home from '../../containers/Homebis'
import NotFound from '../../pages/NotFound'
import ScrollToTop from '../ScrollToTop/ScrollToTop'
import Contact from '../../containers/Contact'
import Financement from '../../containers/Financement'
import Formation from '../../containers/Formation'
import Formations from '../../containers/Formations'
import FormationsByKey from '../../containers/FormationsByKey'
import FormationsBySecteur from '../../containers/FormationsBySecteur'
import FormationsBySecteurAndKey from '../../containers/FormationsBySecteurAndKey'
import FormationsByName from '../../containers/FormationsByName'
import CourseSecteur from '../../containers/CourseSecteur'
import CourseProg from '../../containers/CourseProg'
import JobFiche from '../../containers/JobFiche'
import Job from '../../containers/Job'
import Wefor from '../../containers/Wefor'
import AccountHome from '../../containers/AccountHome'
import AccountFacture from '../../containers/AccountFacture'
import AccountFinancement from '../../containers/AccountFinancement'
import AccountDoc from '../../containers/AccountDoc'
import AccountCourse from '../../containers/AccountCourse'
import AccountProfil from '../../containers/AccountProfil'
import AccountJobs from '../../containers/AccountJobs'
import AccountCandidats from '../../containers/AccountCandidats'
import AccountOcean from '../../containers/AccountOcean'
import AccountRecrutement from '../../containers/AccountRecrutement'
import Login from '../../containers/Login'
import LoginValid from '../../containers/LoginValid'
import FormCourse from '../../containers/FormCourse'
import LoginLost from '../../containers/LoginLost'
import NewPassword from '../../containers/NewPassword'
import SignIn from '../../containers/SignIn'
import SignInEntreprise from '../../containers/SignInEntreprise'
import PreInscription from '../../containers/PreInscription'
import Legal from '../../containers/Legal'
import CGV from '../../pages/CGV'
import Pdc from '../../pages/Pdc'
import NewsFlux from '../../containers/NewsFlux'
import ModalInscription from '../../containers/ModalInscription'
import ModalInscLoader from '../../containers/ModalMessage'
import ModalPostulerTuto from '../../containers/ModalPostulerTuto'
import ModalMessage from '../../containers/ModalInscription'
import Maintenance from '../../components/Maintenance'
import Map from '../Map'
import Arrow from '../ScrollToTop/Arrow'
import { ParallaxProvider } from 'react-scroll-parallax'
import CookieConsent, { Cookies } from "react-cookie-consent"
import PDFDocument from '../PDFDocument'
import FullPageLoader from '../../containers/FullPageLoader'
import ModalCreateLMSSession from '../../containers/ModalCreateLMSSession'
import AccountAdminFacture from '../../containers/AccountAdminFacture'
import AccountAdminApprenant from '../../containers/AccountAdminApprenant'
import AccountAdminCollabs from '../../containers/AccountAdminCollabs'
import AccountAdminUsers from '../../containers/AccountAdminUsers'
import AccountParrainage from '../../containers/AccountParrainage'
import Backdrop from '@mui/material/Backdrop';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import PopupKnowMore from '../../containers/PopupKnowMore';
import HeaderMobile from '../../containers/HeaderMobile'
import Accueil from '../../containers/Accueil';
import FormLms from '../../components/FormLms'
import DownloadBooklet from '../../components/DownloadBooklet';
import Reglement from '../../pages/Reglement';

/**** Import des css ****/
import AppStyled from './AppStyled'
import { setFullPageLoaderRecrutementObj } from '../../actions/login'

const actions = [
  { icon: <FileCopyIcon />, name: 'Copy' },
  { icon: <SaveIcon />, name: 'Save' },
  { icon: <PrintIcon />, name: 'Print' },
  { icon: <ShareIcon />, name: 'Share' },
];


const App = ({isLogged, 
  fullPageLoader, 
  fetchGetCoursesLms, 
  fetchGetOneProgram, 
  viewModal, 
  setWindowTop, 
  fetchSecteurs, 
  fetchFormations, 
  fetchJobs, 
  fetchDomaines, 
  fetchJobFiches, 
  isShowMenu, 
  setIsShowMenu, 
  isShowAccountFormMenu, 
  setIsShowAccountFormMenu, 
  changeActivCourseId, 
  changeActivJobId, 
  courseList, 
  jobsList, 
  modalInscLoaderOpen, 
  changeSigninStep, 
  modalMessageIsOpen, 
  fullPageLoaderConnexion, 
  fullPageLoaderJobInsc, 
  fullPageLoaderContact, 
  fullPageLoaderOcean,
  fullPageLoaderPutAccount,
  fullPageLoaderJobOfferAction,
  fullPageLoaderFacturation,
  fullPageLoaderRecrutementObj,
  fullPageLoaderNews,
  loadConnexion,
  isModalPostulerTutoOpen,
  isHeLogged,
  secteursData,
  domainesData,
  jobsFiches,
  maintenance,
  lastPagePathname,
  setLastPagePathname,
  userRole,
  setCurrentUrl,
  slugSecteur,
  slugKeyword,
  slugFormation,
  setFullSlugCourse,
  saveSlugs,
  redirect,
  currentProfilUser
}) => {

  let windowTop = useScrollPosition()
  let location = useLocation().pathname
  const navigate = useNavigate()

  useEffect(() => {
    TagManager.initialize({ gtmId: 'GTM-TGN2JSC' });
    setCurrentUrl(location)
  }, []);

  const [testConnect, setTestConnect] = useState(false)
  const [input, setInput] = useState(false)
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const [hover, setHover] = useState(false)
  const [hoverB, setHoverB] = useState(false)
  const [width, setWidth] = useState(window.innerWidth)

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  const handleMouseLeave = () => {
    setHover(true);
  }

  const handleDoNoting = () => {
  }

  const handleMouseEnter = () => {
    setHover(true);
  }

  /*
  chargement début de l'app
  useEffect(() => {
    if (secteursData.length === 0) {
      fetchSecteurs()
    }
  }, []);
  useEffect(() => {
    if (domainesData.length === 0) {
      fetchDomaines()
    }
  }, []);
  useEffect(() => {
    if (jobsFiches.length === 0) {
      fetchJobFiches()
    }
  }, []);
  useEffect(fetchGetOneProgram, []);
  useEffect(fetchGetCoursesLms, []);
  */

  useEffect(() => {
    if (location !== '/signin') {
      changeSigninStep(1)
    }
    setLastPagePathname(location)
  }, [location]);
  useEffect(() => {
    if (windowTop === 0) {
      setWindowTop(true)
    } else {
      setWindowTop(false)
    }
  }, [windowTop]);

  return (
    <AppStyled
      onMouseLeave={width > 1079 ? handleMouseLeave : handleDoNoting}
      onClick={() => { 
        if(isShowMenu === true) {
          setIsShowMenu(false)
        }
        /*if(isShowAccountFormMenu === true) {
          setIsShowAccountFormMenu(false)
      }*/}}
    >
      {testConnect ?
      <>        
      <form 
        className="account-form-comp"
        onSubmit={(event) => {
          event.preventDefault();
        }}
      >
        <input type='password' name='pwd' onChange={(event) => setInput(event.target.value)} />
        <input type='submit' name='submit' onClick={() => {
          if(input === 'Motdepasse92.'){setTestConnect(false)}
        }} />
        </form>
      </>
      :
      <>
       <Helmet>
        <title>WEFOR</title>
        <meta name='description' content="Wefor vous propose une multitude de services depuis la formation de vos collaborateurs jusqu'au recrutement de nouveaux talents."/>
        <meta name='keywords' content='Wefor, formation, cabinet de recrutement'/>
        <link rel="canonical" href="https://www.wefor.fr/" />
      </Helmet>
      <ScrollToTop lastPagePathname={lastPagePathname}/>
      {currentProfilUser === 'Entreprise' &&
      <div className='bottom-right-item'>
        <DownloadBooklet />
      </div>
      }
      {location !== '/accueil' && 
        <HeaderMobile />
      }
      {/*width > 1079 && hover && !isHeLogged &&
        <PopupKnowMore deviceWidth={width}/>
      }
      {width < 1080 && !isHeLogged &&
        <PopupKnowMore deviceWidth={width}/>
      */}
      {location !== '/accueil' && 
        <Arrow /> 
      }
      {fullPageLoader &&
      <FullPageLoader />
      }
      {fullPageLoaderConnexion &&
      <FullPageLoader />
      }
      {fullPageLoaderNews &&
      <FullPageLoader />
      }
      {fullPageLoaderJobInsc &&
      <FullPageLoader />
      }
      {fullPageLoaderContact &&
      <FullPageLoader />
      }
      {fullPageLoaderOcean &&
      <FullPageLoader />
      }
      {fullPageLoaderPutAccount &&
      <FullPageLoader />
      }
      {fullPageLoaderJobOfferAction &&
      <FullPageLoader />
      }
      {fullPageLoaderFacturation &&
      <FullPageLoader />
      }
      {fullPageLoaderRecrutementObj &&
      <FullPageLoader />
      }
      {loadConnexion &&
      <FullPageLoader />
      }
      {viewModal &&
        <ModalInscription />
      }
      {modalInscLoaderOpen &&
        <ModalInscLoader />
      }
      {isHeLogged && isModalPostulerTutoOpen && userRole !== 'entreprise' &&
        <ModalPostulerTuto />
      }
        {maintenance ?
        <Maintenance />
        :
          <>
            <ParallaxProvider>
            <Routes>
              <Route path='*' element={<NotFound />} action={() => console.log('hello path')}/>
              <Route index path="/" element={<Home/>} action={() => console.log('hello path')}/>
              <Route path="/accueil" element={<Accueil/>} />
              <Route path="/contact" element={<Contact/>} action={() => console.log('hello path')}/>
              <Route path="/financement" element={<Financement/>} />
              <Route path="/formation" element={<Formation/>} />

              {/* Start new routes 
              <Route path="/formations" element={<Formations/>} />
              <Route path="/formations/mot-cle/:keyword" element={<FormationsByKey />} />
              <Route path="/formations/:secteur" element={<FormationsBySecteur />} />
              <Route path="/formations/:secteur/mot-cle/:keyword" element={<FormationsBySecteurAndKey />} />
              <Route path="/formations/:secteur/:name" element={<FormationsByName/>} />
              {/* End new routes */}
              
              <Route path="/qui-sommes-nous" element={<Wefor/>} />
              <Route path="/fiche-metier/:name" element={<JobFiche />} />
              <Route path="/formation/:idcourse" element={<Formation/>} />
              <Route path="/job/:idjob" element={<Job/>} />
              <Route path="/job" element={<Job/>} />
              {/* <Route path="/actualites" element={<NewsFlux/>} /> */}
              <Route path="/account/home" element={<AccountHome />} />
              <Route path="/account/admin-facture" element={<AccountAdminFacture />} />
              <Route path="/account/admin-apprenant" element={<AccountAdminApprenant />} />
              <Route path="/account/admin-collabs" element={<AccountAdminCollabs />} />
              <Route path="/account/admin-users" element={<AccountAdminUsers />} />
              <Route path="/account/profil" element={<AccountProfil />} />
              <Route path="/account/course" element={<AccountCourse />} />
              <Route path="/account/jobs" element={<AccountJobs />} />
              <Route path="/account/mes-financements" element={<AccountFacture />} />
              <Route path="/account/financements" element={<AccountFinancement />} />
              <Route path="/account/documents" element={<AccountDoc />} />
              <Route path="/account/candidats" element={<AccountCandidats />} />
              <Route path="/account/ocean" element={<AccountOcean />} />
              <Route path="/account/recrutement" element={<AccountRecrutement />} />
              <Route path="/account/parrainage" element={<AccountParrainage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/login-validation" element={<LoginValid />} />
              {/* <Route path="/formulaire-formation" element={<FormCourse/>} /> */}
              <Route path="/mot-de-passe-oublie" element={<LoginLost />} />
              <Route path="/nouveau-mot-de-passe" element={<NewPassword />} />
              <Route path="/SignIn" element={<SignIn />} />
              <Route path="/sign-in-entreprise" element={<SignInEntreprise />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/politique-de-confidentialite" element={<Pdc />} />
              <Route path="/reglement-interieur" element={<Reglement />} />
              <Route path="/pre-inscription" element={<PreInscription />} />
              <Route path="/conditions-generales-de-vente" element={<CGV />} />
              <Route path="/connexion-lms" element={<FormLms />} />
              {/* 
              <Route path="/dev-componant" element={<DownloadBooklet />} />
              */}
            </Routes>
            </ParallaxProvider>
            <ToastContainer className="toast-container" />
            <CookieConsent
              location="bottom"
              buttonText="Continuer"
              cookieName="myAwesomeCookieName2"
              style={{ background: "#202c3c" }}
              buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
              expires={150}
              buttonClasses="btn-orange"
            >
              Nous utilisons des cookies sur notre site web pour vous offrir la meilleure expérience possible. Si vous cliquez sur continuer, nous partons du principe que vous acceptez notre{" "}<Link to='politique-de-confidentialite'>Politique de confidentialité</Link>
            </CookieConsent>
          </>
        }
      </>
      }
    </AppStyled>
  )
}

App.propTypes = {
  fetchSecteurs: PropTypes.func.isRequired
}

export default App